import React, { useState } from 'react'
import { Popup } from '../../components/Popup'
import { Button } from '../../components/Button';
import { returnFlyers } from '../../redux/advertSlice';
import { Input } from '../../components/Input';
import { useDispatch } from 'react-redux';

export const ReturnFlyersPopup = ({closeFn, data}) => {
    const {givenFlyersCount: flyerList} = data;
    const dispatch = useDispatch();
    const [returnCount, setReturnCount] = useState(flyerList.map(f => ({_id: f.flyer._id, count: f.returnedCount})));
    const returnCountHandler = (count, _id) => {
        setReturnCount(prev => prev.map(f => f._id !== _id ? f : ({...f, count})))
    }

    const resetFn = () => {
        setReturnCount(flyerList.map(f => ({_id: f.flyer._id, count: f.returnedCount})));
        closeFn();
    }
    const returnHandler = () => {
        const body = {
            finishId: data.finishId,
            list: returnCount,
        }
        dispatch(returnFlyers({body, resetFn}));
    }

    return (
      <Popup title='Возврат листовок' closeFn={closeFn} button={<Button text='Вернуть' onClick={returnHandler}/>}>
            {flyerList.map(f => {
                const thisReturnCount = returnCount.find(fc => fc._id === f.flyer._id)?.count;
                const remainCount = f.count - f.realSpreadCount - thisReturnCount;
                const maxCountToReturn = f.count - f.realSpreadCount;
                return (
                    <div key={f.flyer._id} className='return-flyer-item'>
                        <span>{f.flyer.name}</span>
                        <Input label='Вернул всего' type='number' min={0} max={maxCountToReturn}
                            value={returnCount.find(fc => fc._id === f.flyer._id)?.count}
                            changeHandler={(e) => returnCountHandler(+e.target.value, f.flyer._id)}
                        />
                        <span>остаток: {remainCount}</span>
                </div>
                )
            })}
    </Popup>
    )
}
